module.exports = "<captains-page></captains-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appFleet/captains.html
// module id = 1330
// module chunks = 0